import React, { useState, useReducer, useEffect, useMemo } from 'react'
import { navigate } from 'gatsby-link'
import TopSide from '../Head/TopSide'
import accountForm from '../../content/account-form'
import {
  citizenshipsKz,
  citizenshipsRf,
  allFiscalCountriesKz,
  allFiscalCountriesRf,
  allFiscalCitizenshipCountries,
  addressCountries,
  addressFiscalCountriesKz,
  addressFiscalCountriesRf,
  IpCitizenshipCountries,
} from '../../content/countries'
import RegionCityList from '../../content/region-city'
import RegionCityListEn from '../../content/region-city_en'
import RegionCityListKz from '../../content/region-city_kz'
import KzRegionCityList from '../../content/kz_region-city'
import KzRegionCityListEn from '../../content/kz_region-city_eng'
import KzRegionCityListKz from '../../content/kz_region-city_kz'
import AcceptConditions from '../AcceptConditions/AcceptConditions'
import ScreenOneRus from '../../Layouts/Physical/RusInstance/ScreenOne'
import ScreenOneKzt from '../../Layouts/Physical/KztInstance/ScreenOne'
import ScreenTwo from '../../Layouts/Physical/ScreenTwo'
import ScreenThree from '../../Layouts/Physical/ScreenThree'
import ScreenThreeCart from '../../Layouts/Physical/ScreenThreeCart'
import ScreenFour from '../../Layouts/Physical/ScreenFour'

import FiscalScreenOne from '../../Layouts/Fiscal/FiscalScreenOne'
import FiscalScreenTwo from '../../Layouts/Fiscal/FiscalScreenTwo'
import FiscalScreenThree from '../../Layouts/Fiscal/FiscalScreenThree'
import FiscalScreenFour from '../../Layouts/Fiscal/FiscalScreenFour'

import ConfirmRemember from '../../Layouts/ConfirmRemember/ConfirmRemember'

import {
  getInitialState,
  actions,
  reducer,
  INITIAL_STATE,
} from '../../state-actions-reducers'
import { saveState, resetLocalStorage, saveCart, getSavedOrderId } from '../../local-storage'
import { iframeResizer } from 'iframe-resizer'
import { convToInt, useDefer } from '../../utils/helpers'
import { validateStep } from '../../validate/validators'
import { useToken, getUserAndFormId } from '../../hooks/useTokenCustomHook'
import { INSTANCE, SUBMIT_SUCCESS } from '../../server-parameters'

import { COUNTRY } from '../../server-parameters'

import {
  profileType_Physical,
  profileType_Fiscal,
} from '../../state-actions-reducers'

import styles from './IndexPresentationComponent.module.scss'
import BackButtonImg from '../../images/black-arrow-left.svg'
import AlarmImg from '../../images/alarm.svg'
import { useQueryContext } from '../../pages'
//const customstyles = require('./customstyles.css')
//import * as customstyles from './customstyles.css'
import '../../styles/customstyles.css'
import { Lang } from "../../types/common-types";
import LoadingScreen from '../../Layouts/LoadingScreen/LoadingScreen'
import { getCitizenships, getCity } from '../../hooks/useGetCityCustomHook'
import InfoMessage from '../../shared/InfoMessage/InfoMessage'
import Button from '../../shared/Buttons/Button'
import Footer from '../Footer/Footer'

/* REACT COMPONENT */
export default function Index() {
  const query = useQueryContext()
  const [searchParams, setSearchParams] = useState(new URLSearchParams())
  useEffect(() => {
    setSearchParams(new URLSearchParams(query))
  }, [query])
  const [lang, setLang] = useState<Lang>('rus')
  const [parentUrl, setParentUrl] = useState('')
  const [cartList, setCartList] = useState('[]')
  const [nextStep, setNextStep] = useState(false)
  // Set state
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE)
  const TOTAL_STEPS = useMemo(() => {
    return state.profileType === profileType_Fiscal ? 5 : 4
  }, [state.profileType])

  const [settingsCitizenship, setSettingsCitizenships] = useState<{ countryCode: string; isActive?: boolean; }[]>([])

  const citizenshipsList = useMemo(() => {
    const instanceList = COUNTRY === "kz" ? citizenshipsKz : citizenshipsRf
    const filtersList = settingsCitizenship?.filter((e: { countryCode: string; isActive?: boolean; }) => !!instanceList.find((f) => f.value === e.countryCode))
    return filtersList?.map((m) => {
      return {
        value: m.countryCode,
        label: instanceList.find((f) => f.value === m.countryCode)?.label,
        disabled: !m.isActive
      }
    }).sort((a: any, b: any) => {
      if (a.label[lang].toLowerCase() < b.label[lang].toLowerCase()) {
        return -1
      }
      if (a.label[lang].toLowerCase() > b.label[lang].toLowerCase()) {
        return 1
      }
      return 0
    })
      .sort((x: any, y: any) =>
        ['398', '643'].includes(x.value.toString()) ? -1 : 1
      )
      .sort((x: any, y: any) => {
        return COUNTRY === "kz" ?
          x.value.toString() === "398" ? -1 : y.value.toString() == "398" ? 1 : 0
          : x.value.toString() === "643" ? -1 : y.value.toString() == "643" ? 1 : 0
      })
  }, [settingsCitizenship])

  async function getSettingsCitizenships() {
    getCitizenships().then((response) => {
      setSettingsCitizenships(response)
      setLoading(false)
    })
  }
  useEffect(() => {
    getSettingsCitizenships()
  }, [COUNTRY])

  const allFiscalSort = useMemo(() => {
    if (COUNTRY === 'kz') {
      return allFiscalCountriesKz
        .sort((a: any, b: any) => {
          if (a.label[lang].toLowerCase() < b.label[lang].toLowerCase()) {
            return -1
          }
          if (a.label[lang].toLowerCase() > b.label[lang].toLowerCase()) {
            return 1
          }
          return 0
        })
        .sort((x: any, y: any) =>
          ['398', '643'].includes(x.value.toString()) ? -1 : 1
        )
        .sort((x: any, y: any) => {
          return x.value.toString() === '398'
            ? -1
            : y.value.toString() == '398'
              ? 1
              : 0
        })
    } else {
      return allFiscalCountriesRf
    }
  }, [COUNTRY])

  const allCitizenshipsFiscalSort = useMemo(() => {
    if (COUNTRY === 'kz') {
      return allFiscalCitizenshipCountries
        .sort((a: any, b: any) => {
          if (a.label[lang].toLowerCase() < b.label[lang].toLowerCase()) {
            return -1
          }
          if (a.label[lang].toLowerCase() > b.label[lang].toLowerCase()) {
            return 1
          }
          return 0
        })
        .sort((x: any, y: any) =>
          ['398', '643'].includes(x.value.toString()) ? -1 : 1
        )
        .sort((x: any, y: any) => {
          return x.value.toString() === '398'
            ? -1
            : y.value.toString() == '398'
              ? 1
              : 0
        })
    } else {
      return IpCitizenshipCountries
    }
  }, [COUNTRY])

  const allCitizenshipsAddressSort = useMemo(() => {
    if (COUNTRY === 'kz') {
      return addressCountries
        .sort((a: any, b: any) => {
          if (a.label[lang].toLowerCase() < b.label[lang].toLowerCase()) {
            return -1
          }
          if (a.label[lang].toLowerCase() > b.label[lang].toLowerCase()) {
            return 1
          }
          return 0
        })
        .sort((x: any, y: any) =>
          ['398', '643'].includes(x.value.toString()) ? -1 : 1
        )
        .sort((x: any, y: any) => {
          return x.value.toString() === '398'
            ? -1
            : y.value.toString() == '398'
              ? 1
              : 0
        })
    } else {
      return addressCountries
        .sort((a: any, b: any) => {
          if (a.label[lang].toLowerCase() < b.label[lang].toLowerCase()) {
            return -1
          }
          if (a.label[lang].toLowerCase() > b.label[lang].toLowerCase()) {
            return 1
          }
          return 0
        })
        .sort((x: any, y: any) =>
          ['112', '398', '643'].includes(x.value.toString()) ? -1 : 1
        )
        .sort((x: any, y: any) => {
          return x.value.toString() === '643'
            ? -1
            : y.value.toString() == '643'
              ? 1
              : 0
        })
    }
  }, [COUNTRY])

  const allCitizenshipsFiscalAddressSort = useMemo(() => {
    if (COUNTRY === 'kz') {
      return addressFiscalCountriesKz
        .sort((a: any, b: any) => {
          if (a.label[lang].toLowerCase() < b.label[lang].toLowerCase()) {
            return -1
          }
          if (a.label[lang].toLowerCase() > b.label[lang].toLowerCase()) {
            return 1
          }
          return 0
        })
        .sort((x: any, y: any) =>
          ['398', '643'].includes(x.value.toString()) ? -1 : 1
        )
        .sort((x: any, y: any) => {
          return x.value.toString() === '398'
            ? -1
            : y.value.toString() == '398'
              ? 1
              : 0
        })
    } else {
      return addressFiscalCountriesRf
    }
  }, [COUNTRY])

  useEffect(() => {
    if (searchParams.get('lang') === 'eng') {
      setLang('eng')
      dispatch({ type: actions.LOCALE, data: 'EN' })
    } else if (searchParams.get('lang') === 'kz') {
      setLang('kz')
      dispatch({ type: actions.LOCALE, data: 'KZ' })
    }
    setParentUrl(searchParams.get('parentUrl')??'')
  }, [searchParams])

  const RegionCityListLocalesRegistered = useMemo(() => {
    return searchParams.get('lang') === 'kz'
      ? state.addressRegisteredCountry === '643'
        ? RegionCityListKz
        : state.addressRegisteredCountry === '398'
          ? KzRegionCityListKz
          : []
      : searchParams.get('lang') === 'eng'
        ? state.addressRegisteredCountry === '643'
          ? RegionCityListEn
          : state.addressRegisteredCountry === '398'
            ? KzRegionCityListEn
            : []
        : state.addressRegisteredCountry === '643'
          ? RegionCityList
          : state.addressRegisteredCountry === '398'
            ? KzRegionCityList
            : []
  }, [searchParams.get('lang'), state.addressRegisteredCountry])
  const RegionCityListLocalesFactual = useMemo(() => {
    return searchParams.get('lang') === 'kz'
      ? state.addressFactualCountry === '643'
        ? RegionCityListKz
        : state.addressFactualCountry === '398'
          ? KzRegionCityListKz
          : []
      : searchParams.get('lang') === 'eng'
        ? state.addressFactualCountry === '643'
          ? RegionCityListEn
          : state.addressFactualCountry === '398'
            ? KzRegionCityListEn
            : []
        : state.addressFactualCountry === '643'
          ? RegionCityList
          : state.addressFactualCountry === '398'
            ? KzRegionCityList
            : []
  }, [searchParams.get('lang'), state.addressFactualCountry])

  const RegionCityListLocalesResidence = useMemo(() => {
    return searchParams.get('lang') === 'kz'
      ? state.addressResidenceCountry === '643'
        ? RegionCityListKz
        : state.addressResidenceCountry === '398'
          ? KzRegionCityListKz
          : []
      : searchParams.get('lang') === 'eng'
        ? state.addressResidenceCountry === '643'
          ? RegionCityListEn
          : state.addressResidenceCountry === '398'
            ? KzRegionCityListEn
            : []
        : state.addressResidenceCountry === '643'
          ? RegionCityList
          : state.addressResidenceCountry === '398'
            ? KzRegionCityList
            : []
  }, [searchParams.get('lang'), state.addressResidenceCountry])
  const [initialState, setInitialState] = useState(state)
  // Try to load saved state
  useEffect(() => {
    const loadedState = getInitialState(window.localStorage)
    setInitialState(initialState)
    dispatch({
      type: actions.REPLACE,
      data: loadedState,
    })

    const params = new URLSearchParams(location.search)
    var _step = params.get('step') ? +('0' + params.get('step')) : 0
    if (!_step || !loadedState.agreed || _step > TOTAL_STEPS) _step = 0
    if (_step !== loadedState.currentStep)
      dispatch({
        type: actions.CURRENT_STEP,
        data: _step,
      })
  }, [initialState])

  // On mount do not show 0 step if user agreed
  useEffect(() => {
    if (state.currentStep === 0 && state.agreed) {
      dispatch({
        type: actions.CURRENT_STEP,
        data: 1,
      })
    }
  }, [state.currentStep, state.agreed])

  // Set userId and token
  useToken(({ userId, formId }) => {
    dispatch({
      type: actions.USER_ID,
      data: userId,
    })
    dispatch({
      type: actions.FORM_ID,
      data: formId,
    })
  }, [])

  // Save state to localStorage on every change
  useDefer(() => saveState(state, localStorage), [state])

  // When trying to change screen, make sure all fields is valid
  const [invalidFields, setInvalidFields] = useState<string[]>([])
  const [strictValidation, setStrictValidation] = useState(false)

  useEffect(() => {
    if (nextStep) {
      setStrictValidation(true)
      // If no invalid fields so far, validate
      if (invalidFields.length === 0 && state.imageError.length === 0) {
        const invalidFieldsNames = validateStep(state.currentStep, state)
        // If all fields is valid, change step
        if (invalidFieldsNames.length === 0) {
          setStrictValidation(false)
          dispatch({
            type: actions.CURRENT_STEP,
            data: state.currentStep + 1,
          })
          setNextStep(false)
          window.scrollTo(0, 0)
          return
        }
        // If some fields invalid
        setInvalidFields(invalidFieldsNames)
      }
      console.log(invalidFields)
      // Some fields invalid, so prevent movement
      setNextStep(false)
    }
  }, [invalidFields.length, state.imageError, nextStep, state])

  // Revalidate fields on change
  useDefer(
    () => {
      if (strictValidation) {
        setInvalidFields(validateStep(state.currentStep, state))
      }
    },
    [state, strictValidation],
    300
  )

  function handleResetState() {
    dispatch({
      type: actions.RESET,
      data: false,
    });

    ResetState();
  }

  function ResetState(withReload: boolean = true) {
    resetLocalStorage(window.localStorage);
    getUserAndFormId(() => { }, window.localStorage);

    if (withReload) {
      if (lang) {
        dispatch({ type: actions.LOCALE, data: lang.toUpperCase() });
      }
    }
  }

  /* RENDER */
  const step = useMemo(() => {
    return state.currentStep
  }, [state.currentStep])

  useEffect(() => {
    const url = `?lang=${lang}&country=${COUNTRY}&t=${state.profileType}&step=${step}`
    navigate(url)
  }, [step])

  useEffect(() => {
    let cart = []
    for (var key in searchParams.getAll('id')) {
      cart.push({
        guid: searchParams.getAll('guid')[key],
        id: searchParams.getAll('id')[key],
        img: searchParams.getAll('img')[key],
        name: searchParams.getAll('name')[key],
        count: searchParams.getAll('count')[key],
        startDateIso: new Date(
          searchParams.getAll('startDateIso')[key]
        ).toISOString(),
        startDate: searchParams.getAll('startDate')[key],
        startTime: searchParams.getAll('startTime')[key],
        endDateIso: new Date(
          searchParams.getAll('endDateIso')[key]
        ).toISOString(),
        endDate: searchParams.getAll('endDate')[key],
        endTime: searchParams.getAll('endTime')[key],
        valuta: searchParams.getAll('valuta')[key],
        valutaRate: searchParams.getAll('valutaRate')[key],
        price: searchParams.getAll('price')[key],
        discount: searchParams.getAll('discount')[key],
        shift: searchParams.getAll('shift')[key],
      })
    }
    console.log('cart', cart)
    setCartList(JSON.stringify(cart))
    let products = cart.map((product: any) => {
      return { title: product.name, guid: product.guid }
    })
    console.log(products)
    if (products.length > 0) {
      dispatch({ type: actions.GOODS, data: products })
    }
  }, [searchParams])
  useEffect(() => {
    if (window.parentIFrame) {
      window.parentIFrame.size()
      if (step === 5) {
        window.parentIFrame.sendMessage({
          city: state.mainCity,
          name: state.firstName,
          lastName: state.lastName,
          patronymic: state.patronymic,
          mail: state.emails[0],
          phone: state.mobilePhoneNumbers[0],
          comments: state.feedback,
          accessToken: getSavedOrderId(window.localStorage)
        })
      } else {
        window.parentIFrame.sendMessage('scrollTop')
      }
    }
  }, [step])

  useEffect(() => {
    window.iFrameResizer = {
      onMessage: (event: any) => {
        event ? saveCart(JSON.stringify(event.cart), localStorage) : null
      },
    }
  }, [iframeResizer])
  const [loading, setLoading] = useState(true)
  const city = useMemo(() => {
    const cityData = getCity();
    return (cityData as any)?.translations?.find((f: any) => {
      return lang === 'rus'
        ? f.language === 1
        : lang === 'eng'
          ? f.language === 3
          : f.language === 2;
    })?.name;
  }, [lang]);
  const [activeForm, setActiveForm] = useState<'Physical' | 'Company' | 'Individual'>('Physical')
  return (
    <>
      {loading ? <LoadingScreen></LoadingScreen> :
        <div className="container">
          {/* AGREEMENT */}
          {(!state.agreed && step !== TOTAL_STEPS) || step == 0 ? (
            <AcceptConditions
              lang={lang}
              parentUrl={parentUrl}
              accountForm={accountForm}
              state={state}
              dispatch={dispatch}
              activeForm={activeForm}
              changeActiveForm={(e: 'Physical' | 'Company' | 'Individual') => setActiveForm(e)}
            />
          ) : state.profileType == profileType_Fiscal ? (
            <>
              <div className={'row'}>
                {step < 5 &&
                  <div
                    className={styles.backButton + ' ' + 'col-12'}
                    onClick={() => {
                      if (step === 1) {
                        handleResetState()
                      } else {
                        // Turn off strict validation
                        setStrictValidation(false)
                        // Reset invalid fields
                        setInvalidFields([])
                        // Move to prev step
                        dispatch({
                          type: actions.CURRENT_STEP,
                          data: state.currentStep - 1,
                        })
                      }
                    }}
                  >
                    <img src={BackButtonImg} alt="back" />
                    <b>{accountForm.prevButton[lang]}</b>
                  </div>
                }
              </div>
              <form
                className={styles.form}
                onSubmit={event => event.preventDefault()}
              >
                {/* NAME AND BANK */}
                {step === 1 && (
                  <main>
                    <TopSide
                      profileType={state.profileType}
                      accountForm={accountForm}
                      lang={lang}
                      step={step}
                      totalsteps={TOTAL_STEPS}
                      city={city}
                    />
                    <FiscalScreenOne
                      lang={lang}
                      state={state}
                      initialState={initialState}
                      dispatch={dispatch}
                      accountForm={accountForm}
                      citizenshipCountriesList={allCitizenshipsFiscalSort}
                      countriesList={allCitizenshipsFiscalSort}
                      allFiscalCountry={allFiscalSort}
                      addressCountries={allCitizenshipsFiscalAddressSort}
                      regionCityRegistered={RegionCityListLocalesRegistered}
                      regionCityFactual={RegionCityListLocalesFactual}
                      regionCityResidence={RegionCityListLocalesResidence}
                      invalidFields={invalidFields}
                      regionCity={RegionCityList}
                    />
                  </main>
                )}
                {/* UPLOAD DOCS */}
                {step === 2 && (
                  <main>
                    <TopSide
                      profileType={state.profileType}
                      accountForm={accountForm}
                      lang={lang}
                      step={step}
                      totalsteps={TOTAL_STEPS}
                      city={city}
                    />
                    <FiscalScreenTwo
                      lang={lang}
                      state={state}
                      dispatch={dispatch}
                      accountForm={accountForm}
                      invalidFields={invalidFields}
                    />
                  </main>
                )}
                {/* PROXIES NAMES */}
                {step === 3 && (
                  <main>
                    <TopSide
                      profileType={state.profileType}
                      accountForm={accountForm}
                      lang={lang}
                      step={step}
                      totalsteps={TOTAL_STEPS}
                      city={city}
                    />
                    <FiscalScreenThree
                      lang={lang}
                      state={state}
                      initialState={initialState}
                      dispatch={dispatch}
                      accountForm={accountForm}
                      allCitizenships={citizenshipsKz}
                      invalidFields={invalidFields}
                    />
                  </main>
                )}
                {/* GOODS */}
                {step === 4 && (
                  <main>
                    <TopSide
                      profileType={state.profileType}
                      accountForm={accountForm}
                      lang={lang}
                      step={step}
                      totalsteps={TOTAL_STEPS}
                      city={city}
                    />
                    <FiscalScreenFour
                      lang={lang}
                      state={state}
                      initialState={initialState}
                      dispatch={dispatch}
                      accountForm={accountForm}
                      invalidFields={invalidFields}
                      allCitizenships={citizenshipsKz}
                    />
                  </main>
                )}
                {/* SUBMIT LOADING */}
                {(step === 5) && (
                  // This component resets the state on window
                  // close if there is no error.
                  <main>
                    <TopSide
                      profileType={state.profileType}
                      accountForm={accountForm}
                      lang={lang}
                      step={step}
                      totalsteps={TOTAL_STEPS}
                      city={city}
                    />
                    <ScreenFour
                      lang={lang}
                      accountForm={accountForm}
                      form={state}
                      resetState={() => {
                        dispatch({
                          type: actions.RESET,
                          data: false,
                        })
                        ResetState()
                        //resetLocalStorage(window.localStorage)
                      }}
                      nextStep={() => {
                        dispatch({
                          type: actions.CURRENT_STEP,
                          data: state.currentStep + 1,
                        })
                      }}
                      prevStep={() => {
                        getUserAndFormId(({ userId, formId }) => {
                          dispatch({
                            type: actions.USER_ID,
                            data: userId,
                          })
                          dispatch({
                            type: actions.FORM_ID,
                            data: formId,
                          })
                          // Turn off strict validation
                          setStrictValidation(false)
                          // Reset invalid fields
                          setInvalidFields([])
                          // Move to prev step
                          dispatch({
                            type: actions.CURRENT_STEP,
                            data: state.currentStep - 1,
                          })
                        }, localStorage)
                      }}
                    />
                  </main>
                )}
                {(step === 6) && (
                  <main>
                    <ConfirmRemember
                      lang={lang}
                      onAccept={() => {
                        dispatch({
                          type: actions.RESET,
                          data: false,
                        }),
                          ResetState()
                        //resetLocalStorage(window.localStorage)
                      }}
                      accountForm={accountForm}
                      state={state}
                      dispatch={dispatch}
                    />
                  </main>
                )}
              </form>
            </>
          ) : (
            <>
              <div className={'row'}>
                {(step < 4) &&
                  <div
                    className={styles.backButton + ' ' + 'col-12'}
                    onClick={() => {
                      if (step === 1) {
                        handleResetState()
                      } else {
                        // Turn off strict validation
                        setStrictValidation(false)
                        // Reset invalid fields
                        setInvalidFields([])
                        // Move to prev step
                        dispatch({
                          type: actions.CURRENT_STEP,
                          data: state.currentStep - 1,
                        })
                      }
                    }}
                  >
                    <img src={BackButtonImg} alt="back" />
                    <b>{accountForm.prevButton[lang]}</b>
                  </div>
                }
              </div>
              <form
                className={styles.form}
                onSubmit={event => event.preventDefault()}
              >
                {/* NAME AND PASSPORT AND ADDRESES */}
                {step === 1 && (
                  <main>
                    <TopSide
                      profileType={state.profileType}
                      accountForm={accountForm}
                      lang={lang}
                      step={step}
                      totalsteps={TOTAL_STEPS}
                      city={city}
                    />
                    {COUNTRY === 'kz' ? (
                      <ScreenOneKzt
                        lang={lang}
                        state={state}
                        initialState={initialState}
                        dispatch={dispatch}
                        accountForm={accountForm}
                        citizenshipCountriesList={citizenshipsList}
                        countriesList={citizenshipsList}
                        allCitizenships={citizenshipsList}
                        addressCountries={allCitizenshipsAddressSort}
                        regionCityRegistered={RegionCityListLocalesRegistered}
                        regionCityFactual={RegionCityListLocalesFactual}
                        invalidFields={invalidFields}
                      />
                    ) : (
                      <ScreenOneRus
                        lang={lang}
                        state={state}
                        initialState={initialState}
                        dispatch={dispatch}
                        accountForm={accountForm}
                        citizenshipCountriesList={citizenshipsList}
                        countriesList={citizenshipsList}
                        allCitizenships={citizenshipsList}
                        addressCountries={allCitizenshipsAddressSort}
                        regionCityRegistered={RegionCityListLocalesRegistered}
                        regionCityFactual={RegionCityListLocalesFactual}
                        invalidFields={invalidFields}
                      />
                    )}
                  </main>
                )}
                {/* ADDITIONAL */}
                {step === 2 && (
                  <main>
                    <TopSide
                      profileType={state.profileType}
                      accountForm={accountForm}
                      lang={lang}
                      step={step}
                      totalsteps={TOTAL_STEPS}
                      city={city}
                    />
                    <ScreenTwo
                      lang={lang}
                      state={state}
                      initialState={initialState}
                      dispatch={dispatch}
                      accountForm={accountForm}
                      allCitizenships={citizenshipsKz}
                      invalidFields={invalidFields}
                    />
                  </main>
                )}
                {/* GOODS */}
                {step === 3 && (
                  <main>
                    <TopSide
                      profileType={state.profileType}
                      accountForm={accountForm}
                      lang={lang}
                      step={step}
                      totalsteps={TOTAL_STEPS}
                      city={city}
                    />
                    {cartList && JSON.parse(cartList).length > 0 ? (
                      <ScreenThreeCart
                        lang={lang}
                        state={state}
                        dispatch={dispatch}
                        accountForm={accountForm}
                        invalidFields={invalidFields}
                        cart={JSON.parse(cartList)}
                      />
                    ) : (
                      <ScreenThree
                        lang={lang}
                        state={state}
                        dispatch={dispatch}
                        accountForm={accountForm}
                        invalidFields={invalidFields}
                      />
                    )}
                  </main>
                )}
                {/* SUBMIT LOADING */}
                {step === 4 && (
                  <main>
                    <TopSide
                      profileType={state.profileType}
                      accountForm={accountForm}
                      lang={lang}
                      step={step}
                      totalsteps={TOTAL_STEPS}
                      city={city}
                    />
                    <ScreenFour
                      lang={lang}
                      accountForm={accountForm}
                      form={state}
                      cart={JSON.parse(cartList)}
                      resetState={() => {
                        dispatch({
                          type: actions.RESET,
                          data: false,
                        })
                        ResetState()
                        //resetLocalStorage(window.localStorage)
                      }}
                      nextStep={() => {
                        dispatch({
                          type: actions.CURRENT_STEP,
                          data: state.currentStep + 1,
                        })
                      }}
                      prevStep={() => {
                        getUserAndFormId(({ userId, formId }) => {
                          dispatch({
                            type: actions.USER_ID,
                            data: userId,
                          })
                          dispatch({
                            type: actions.FORM_ID,
                            data: formId,
                          })
                          // Turn off strict validation
                          setStrictValidation(false)
                          // Reset invalid fields
                          setInvalidFields([])
                          // Move to prev step
                          dispatch({
                            type: actions.CURRENT_STEP,
                            data: state.currentStep - 1,
                          })
                        }, localStorage)
                      }}
                    />
                  </main>
                )}

                {(step === 5) && (
                  <main>
                    <ConfirmRemember
                      lang={lang}
                      onAccept={() => {
                        dispatch({
                          type: actions.RESET,
                          data: false,
                        }),
                          ResetState()
                        //resetLocalStorage(window.localStorage)
                      }}
                      accountForm={accountForm}
                      state={state}
                      dispatch={dispatch}
                    />
                  </main>
                )}
              </form>
            </>
          )}
          <div className={styles.AnketaFooter}>
            {(invalidFields.length !== 0 || !state.isIdentityOk || state.imageError.length !== 0 || state.serverError) && <InfoMessage type={'alarm'} text={!state.isIdentityOk ? <>
              <span>{accountForm?.validationErrorClientExist?.[lang]}</span>
            </> : state.serverError ? <span>{accountForm.serverError[lang]}</span> : <>
              <span>{accountForm.validationError[lang]}</span>
            </>} />
            }
            <Footer lang={lang} parentUrl={parentUrl} accountForm={accountForm} state={state} dispatch={dispatch} step={step} totalSteps={TOTAL_STEPS} activeForm={activeForm} handleResetState={handleResetState} setStrictValidation={setStrictValidation} invalidFields={invalidFields} setInvalidFields={setInvalidFields} setNextStep={setNextStep} />
          </div>
        </div>}
    </>
  )
}
